import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import Slider from '../../components/slider';
import './styles.css';
import {convertPipeToBrTag} from "../../utils";

/**
 * PromoNavigationContainer
 */
const PromoNavigationContainer = ({
                                    containerId,
                                    containerClass,
                                    pcHeading,
                                    mbHeading,
                                    href,
                                    targetBlank,
                                    children,
                                  }) => {
  const settings = null;
  //
  const getPcHeading = () => {
    if (pcHeading && pcHeading !== '') {
      return pcHeading;
    } else {
      return null;
    }
  };
  const getMbHeading = () => {
    if (mbHeading && mbHeading !== '') {
      return mbHeading;
    } else {
      if (pcHeading && pcHeading !== '') {
        return pcHeading;
      } else {
        return null;
      }
    }
  };
  //console.log('debugmode');
  //
  return (
    <Wrapper
      containerId={containerId}
      containerClass={containerClass}
    >
      <section className="PromoNavigationContainer">
        <h4 className="PromoNavigationContainer__heading">
          {(() => {
            if ((pcHeading !== null && pcHeading !== '') || (mbHeading !== null && mbHeading !== '')) {
              if (href !== null && href !== '') {
                // リンクの設定があった場合
                return (
                  <a className="PromoNavigationContainer__link"
                     href={(href !== null) ? href: null}
                     target={(targetBlank !== null && targetBlank === true) ? '_blank': null}
                  >
                    <span className="PromoNavigationContainer__heading-pc">
                      <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcHeading() || '')}}/>
                    </span>
                    <span className="PromoNavigationContainer__heading-mb">
                      <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbHeading() || '')}}/>
                    </span>
                    <span className="PromoNavigationContainer__heading-text">TOP</span>
                    <span className="PromoNavigationContainer__link-border"/>
                  </a>
                )
              } else {
                // リンクの設定がなかった場合
                return (
                  <div>
                    <span className="PromoNavigationContainer__heading-pc">
                      <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcHeading() || '')}}/>
                    </span>
                    <span className="PromoNavigationContainer__heading-mb">
                      <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbHeading() || '')}}/>
                    </span>
                  </div>
                )
                // return (
                //   <div>
                //     {(pcHeading !== null && pcHeading !== '') ?
                //       <span className="PromoNavigationContainer__heading-pc">
                //         <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcHeading() || '')}}/>
                //       </span>
                //       : null}
                //     {(mbHeading !== null && mbHeading !== '') ?
                //       <span className="PromoNavigationContainer__heading-mb">
                //         <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbHeading() || '')}}/>
                //       </span>
                //       : null}
                //   </div>
                // )
              }
            } else {
              return null;
            }
          })()}
        </h4>
        {(() => {
          if (children !== null) {
            if (children.length <= 4) {
              // 4個以下の場合はパディングを広げる
              return (
                <ul className="PromoNavigationContainer__list-ul">
                  {children.map((child, index) => {
                    return (
                      <li key={index}>{child}</li>
                    )
                  })}
                </ul>
              )
              // } else if (children.length === 5) {
              //     // 5個の場合はパディングを狭める
              //     return (
              //         <ul className="PromoNavigationContainer__list-ul col5">
              //             {children.map((child, index)=> {
              //                 return (
              //                     <li key={index}>{child}</li>
              //                 )
              //             })}
              //         </ul>
              //     )
            } else {
              // 5個以上の場合はスライドにする
              return (
                <div className="PromoNavigationContainer__slider">
                  <Slider settings={settings}>
                    {children.map((child, index) => {
                      return (
                        <div key={index}>{child}</div>
                      )
                    })}
                  </Slider>
                </div>
              )
            }
          } else {
            return null;
          }
        })()}
      </section>
    </Wrapper>
  )
};
PromoNavigationContainer.propTypes = {
  containerId: PropTypes.string,
  containerClass: PropTypes.string,
  pcHeading: PropTypes.string,
  mbHeading: PropTypes.string,
  href: PropTypes.string,
  targetBlank: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.node),
};
PromoNavigationContainer.defaultProps = {
  containerId: null,
  containerClass: null,
  pcHeading: null,
  mbHeading: null,
  href: null,
  targetBlank: null,
  children: null,
};
export default PromoNavigationContainer;



// WEBPACK FOOTER //
// ./src/containers/promo-navigation-container/index.jsx